/**
 * 链接地址
 * @description 注意事项：
 * 1. 帮助中心的链接必须携带多语言，否则会跳转帮助中心首页
 * 2. 涉及多语言的连接通过 {{param}} 模板字符串方式配置。
 * 3. 使用的链接若有变量，通过util中的render方法替换字符串
 * 4. https://www.bybit.com域名删除后跟着环境域名走，非这个域名的需设置
 */

/** 社媒 */
export const TWITTER_LINK = 'https://twitter.com/Bybit_Web3';
export const TELEGRAM_LINK = 'https://t.me/BybitEnglish';
export const DISCORD_LINK = 'https://discord.gg/bybit';

/** 关于我们 */
export const ANNOUNCEMENT_LINK = 'https://announcements.bybit.com/{locale}/article_filter/WEB3/';
export const BLOG_LINK = 'https://blog.bybit.com/{locale}/';
export const PRIVACY_POLICY_LINK = '/{locale}/help-center/bybitHC_Article?id=000001786';
/** 用户协议 */
export const USER_AGREEMENT_LINK = '/{locale}/help-center/article/Bybit-Web3-User-Agreement';

/** web3开发文档 */
export const DEVELOPER_LINK = 'https://bybit-web3.github.io/getting-started';

/** 期货默认地址 */
export const TRADE_PATH = '/trade/usdt/BTCUSDT';

export const LOCATION_ORIGIN = typeof window !== 'undefined' ? window?.location?.origin : '';
// app 下载链接
export const DOWNLOAD_LINK = `${LOCATION_ORIGIN}/download?utm_source=web3homepaged&utm_medium=picscann&utm_campaign=appdownload`;

/** release notes */
export const RELEASE_NOTES_LINK = 'https://bybit-web3.github.io/release-notes';
